export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10740.af79bad1.jpg";